import Box from '@mui/material/Box'

function BasePageLayout({title, children}) {
    return (
        <>
            <Box sx={{ p:3, pt: 1 }}>
                <Box sx={{textAlign : 'left'}}>
                    <h2>{title}</h2>
                </Box>
                <Box>
                    {children}
                </Box>

            </Box>
        </>
    )
}

export default BasePageLayout